import { cn } from '@/lib/utils';

/**
 * Brand marks, inlined from the supplied Logo.svg so they render instantly and can be recoloured.
 * Replace these paths if the logo changes.
 */
export function BrandMark({
  className,
  color = '#FFFFFF',
  shade = '#EFEFEF',
}: {
  className?: string;
  color?: string;
  shade?: string;
}) {
  return (
    <svg viewBox="37.2 14.6 28.8 28.8" className={className} aria-hidden fill="none">
      <path
        d="M46.8229 29.076V29.1552C50.1948 29.1681 53.3672 30.0297 56.1392 31.5389C57.2942 32.1683 58.3797 32.909 59.381 33.7481C62.1573 36.074 64.2847 39.1492 65.4545 42.6664V42.934H37.6623V15.0649H65.4556V15.3261C64.3156 18.9043 62.1883 22.0384 59.3959 24.406C58.3915 25.258 57.3017 26.0116 56.1403 26.6516C53.3714 28.1748 50.198 29.0514 46.8239 29.076H46.8229Z"
        fill={color}
      />
      <path d="M46.8111 15.0649H37.705V42.9351H46.8111V15.0649Z" fill={shade} />
      <path
        d="M63.8246 30.7907C64.7678 30.7907 65.5325 30.024 65.5325 29.0781C65.5325 28.1323 64.7678 27.3656 63.8246 27.3656C62.8814 27.3656 62.1167 28.1323 62.1167 29.0781C62.1167 30.024 62.8814 30.7907 63.8246 30.7907Z"
        fill={color}
      />
    </svg>
  );
}

export function Logo({ className, label }: { className?: string; label: string }) {
  return (
    <span
      className={cn(
        'inline-flex h-10 w-[71px] items-center justify-center rounded-[13px] bg-primary md:h-11 md:w-[78px] md:rounded-[14px]',
        className,
      )}
    >
      <BrandMark className="size-[19px] md:size-[21px]" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
